export default __webpack_public_path__ + "static/media/0x7e4c577ca35913af564ee2a24d882a4946ec492b.bca026a6.webp";